import { remove } from 'lodash-es'
import { COOKIE_KEY } from '~/constants/config'
import { useTemplate } from '~/features/template/components/info'
import { useCreateWork } from '~/features/createWork'

export enum IAfterLoginActionType {
  'CREATE_WORK',
  'USE_TEMPLATE',
}

interface AfterLoginAction {
  type: IAfterLoginActionType
  payload: any
}

class LoginTaskManager {
  cached: AfterLoginAction[] = []

  get tasks() {
    return this.cached
  }

  set tasks(tasks: AfterLoginAction[]) {
    this.cached = tasks
    sessionSetItem('LOGIN_TASK', tasks)
  }

  constructor() {
    if (import.meta.client) {
      this.tasks = sessionGetItem('LOGIN_TASK') || []
    }
  }

  add(task: AfterLoginAction) {
    const token = getCookie(COOKIE_KEY.USER_TOKEN)
    if (!token?.user_id) {
      remove(this.tasks, (v) => v.type === task.type)
      this.tasks.push(task)
      sessionSetItem('LOGIN_TASK', this.tasks)
    }
  }

  async flush() {
    let proc = Promise.resolve()
    while (this.tasks.length > 0) {
      const task = this.tasks.shift()
      proc = proc.then(() => {
        try {
          if (task?.type === IAfterLoginActionType.CREATE_WORK) {
            const route = useRoute()
            const url = new URL(route.query.redirect as string)
            navigateTo({
              path: url.pathname,
            })
            useCreateWork()
            return
          }
          if (task?.type === IAfterLoginActionType.USE_TEMPLATE) {
            return useTemplate(...task.payload)
          }
        } catch (err) {
          // silently ignore
        }
      })
    }
    await proc
    this.clear()
  }

  remove(task: AfterLoginAction) {
    remove(this.tasks, (v) => v.type === task.type)
  }

  clear() {
    this.tasks = []
  }
}

export const loginTask = new LoginTaskManager()
